AdminConfig = {
	adminUsernames: ['bulleric', 'admin', 'Driven'],
	collections: {
    Bands: {
      tableColumns: [
        { label: 'Bandname', name:'name'},
        { label: 'Raumnummer', name:'roomNumber'},
        { label: 'Email', name:'contactEmail'},
        { label: 'Telefon', name:'contactTelefon'},
        { label: 'Timestamp', name:'modifiedAt'}
      ],
      color: 'red'
    }
  }
}


Router.route('/csve993f15e97a4cfdcb69fcc658c08c231ca1330ddca345c0416ce932b2cef1df4b694', {
  where: 'server',
  action: function () {
    var filename = 'band_export.csv';
    var fileData = "";

    var headers = {
      'Content-type': 'text/csv',
      'Content-Disposition': "attachment; filename=" + filename
    };
    var records = Bands.find({}, {sort: {modifiedAt:-1}});
    var fileData = "Name" + ";" + "Timestamp" + ";" + "Picture" + ";" + "Text" + ";" + "Contact" + ";" + "ContactName" + ";" + "ContactEmail" +  ";" + "Room" + ";" + "Style" + ";" + "PromoText" + ";" + "Homepage" + ";" + "Facebook" + ";" +
  "Members" + "\n";


    records.forEach(function(rec = {"name": "", "modifiedAt":"", "contactName":"", "contactTelefon":"", "contactEmail":"", "roomNumber":"", "style":"", "promo":"", "homepage":"", "facebook":"", "members":""}) {
      if ( rec.members ) {
        var membersCount =  rec.members.length
      } else {
        var membersCount = 0
      } 
      if ( rec.promo) {
        var promo = "x"
      } else {
        var promo = ""
      } 

      if ( rec.picture ) {
        var picture = "x"
      } else {
        var picture = ""
      } 

      fileData += "\"" + rec.name + "\"" + ";" + rec.modifiedAt + ";" + "\"" + picture + "\"" + ";" + "\”" + promo + "\"" + ";" + rec.contactTelefon+ ";" + "\"" + rec.contactName + "\"" + ";" + "\"" + rec.contactEmail + "\"" +  ";" + "\"" + rec.roomNumber + "\"" + ";" + "\"" + rec.style + "\"" + ";" + "\"" + rec.promo + "\"" +  ";" + "\"" + rec.homepage+ "\"" + ";" +  rec.facebook + ";" +  membersCount + "\n";
    });
      this.response.writeHead(200, headers);
    return this.response.end(fileData);
  }
});


Router.route('/csvemembers993f15e97a4cfdcb69fcc658c08c231ca1330ddca345c0416ce932b2cef1df4b694', {
  where: 'server',
  action: function () {
    var filename = 'band_export.csv';
    var fileData = "";

    var headers = {
      'Content-type': 'text/csv',
      'Content-Disposition': "attachment; filename=" + filename
    };
    var records = Bands.find({}, {sort: {modifiedAt:-1}});
    var fileData = "Name" + ";" + "Member 1" + ";" + "Instruments" + ";" + "Member 2" + ";" + "Instruments" + ";" + "Member 3" + ";" + "Instruments" +  ";" + "Member 4 " + ";" + "Instruments" + ";" + "Member 5" + ";" + "Instruments" + ";" + "Member 6" + ";" + "INstruments" + "\n";


    records.forEach(function(rec = {"name": "", "members":""}) {

      var members = rec.members;
      var  preparedMembers="";

      if ( members ) {
        for (var i in members) {
	  if ( members[i] ) {
            if (typeof members[i]["name"] != null && typeof members[i]["name"] != null ) {
              preparedMembers += ";" + members[i]["name"] + ";" + members[i]["instrument"];
            }
	  }
        }

      }
      fileData += "\"" + rec.name +  "\""  + preparedMembers +  "\n";
    });
    this.response.writeHead(200, headers);
    return this.response.end(fileData);
  }
});


Router.route('/text993f15e97a4cfdcb69fcc658c08c231ca1330ddca345c0416ce932b2cef1df4b694', {
  where: 'server',
  action: function () {
    var fileData = "";
    var filename = "bandexport.txt";
    var headers = {
      'Content-type': 'text/csv',
      'Content-Disposition': "attachment; filename=" + filename
    };


    var records = Bands.find({}, {sort: {modifiedAt:-1}});
    var fileData = "Name" + ";" + "Timestamp" + ";" + "Picture" + ";" + "Text" + ";" + "Contact" + ";" + "ContactName" + ";" + "ContactEmail" +  ";" + "Room" + ";" + "Style" + ";" + "PromoText" + ";" + "Homepage" + ";" + "Facebook" + ";" +
  "Members" + "\n";


    records.forEach(function(rec = {"name": "", "modifiedAt":"", "contactName":"", "contactTelefon":"", "contactEmail":"", "roomNumber":"", "style":"", "promo":"", "homepage":"", "facebook":"", "members":""}) {

      if ( rec.members ) {
        var membersCount =  rec.members.length
        var members = rec.members;
        var  preparedMembers="";
        if ( members ) {
          for (var i in members) {
            if ( members[i] ) {
              if (typeof members[i]["name"] != null && typeof members[i]["name"] != null ) {
                preparedMembers += members[i]["name"] + " - " + members[i]["instrument"];
              }
            }
          }
        }
      } else {
        var preparedMembers = "";
      }

      if ( rec.promo) {
        var promo = "x"
      } else {
        var promo = ""
      } 

      if ( rec.picture ) {
        var picture = "x"
      } else {
        var picture = ""
      } 

      fileData += "\n\n\n\n\n" + rec.name + "\n\n" + rec.contactTelefon + "\n\n" + rec.contactName + "\n\n" + rec.contactEmail + "\n\n" + rec.roomNumber + "\n\n" + rec.style + "\n\n" + rec.promo + "\n\n" + rec.homepage + "\n\n"  + rec.facebook + "\n\n" + preparedMembers + "\n\n" + "http://bewerbung.kalkwerk.org/cfs/files/images/" + rec.picture + "\n\n -------------------------------";
    });
    this.response.writeHead(200, headers);
    return this.response.end(fileData);
  }
});

